import { render, staticRenderFns } from "./mostCourse_bar.vue?vue&type=template&id=2c79e68a&scoped=true&"
import script from "./mostCourse_bar.vue?vue&type=script&lang=js&"
export * from "./mostCourse_bar.vue?vue&type=script&lang=js&"
import style0 from "./mostCourse_bar.vue?vue&type=style&index=0&id=2c79e68a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79e68a",
  null
  
)

export default component.exports